import React from 'react';
import './AdminError.module.scss';
import Button from 'components/UI/Button/Button';
import { useDispatch } from 'react-redux';
import logoutUser from 'actions/authentication/logout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSignOut } from '@fortawesome/pro-regular-svg-icons';

function AdminError() {
    const dispatch = useDispatch();
    return (
        <div styleName="container">
            <div styleName="box">
                <img src="/images/spiekdigitaal.svg" alt="spiek digitaal" />
                <p>
                    Het lijkt er op dat je al bent ingelogd als behandelaar. Ga
                    terug naar de behandelaarskant of log uit om in te loggen
                    als leerling.
                </p>
                <div styleName="row">
                    <a href="/admin">
                        <Button>
                            <FontAwesomeIcon icon={faArrowLeft} />
                            Behandelaarskant
                        </Button>
                    </a>
                    <Button
                        onClick={() => {
                            dispatch(logoutUser());
                        }}
                    >
                        Uitloggen <FontAwesomeIcon icon={faSignOut} />
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default AdminError;
